<template>
  <div class="site-management">
    <div class="search-pane">
      <pro-search 
      :fileds="SearchFiled"
      :form="queryForm"
      @search="handleSearch"
      @reset="handleReset"
      />
    </div>
    <div class="table-content">
      <div class="crate-btn">
      <a-button v-auth="$_ButtonPermission.SITEMANAGEMENT_ADD" type="primary"  @click="createSite()">
        <a-icon type="plus" />
        新增地址
      </a-button>
      <a-button style="margin-left: 8px;" @click="handleImport">批量导入</a-button>
      <a-button style="margin-left: 8px;" @click="handleExport">批量导出</a-button>
    </div>
    <a-table
      :columns="COLUMNS"
      :data-source="dataList"
      :scroll="{ x: 'calc(700px + 50%)'}"
      :pagination="pagination"
      :loading="loading.getData"
      class="table-multip"
      row-key="id"
      @change="tableChange"
    >
      <template slot="status" slot-scope="text">
        <div>
          <span :class="[STATUS[text] === STATUS[1] ? 'enabled' : 'disabled', 'status-tag']" />
          {{STATUSPARAMS[text]}}
        </div>
      </template>
      <template slot="stationName" slot-scope="text">
        <a-tooltip>
          <template slot="title">{{text}}</template>
          <span class="ellipsis2">{{text}}</span>
        </a-tooltip>
      </template>
      <template slot="address" slot-scope="text">
        <a-tooltip>
          <template slot="title">{{text}}</template>
          <span class="ellipsis2">{{text}}</span>
        </a-tooltip>
      </template>
      <template slot="action" slot-scope="text, record">
        <a v-auth="$_ButtonPermission.SITEMANAGEMENT_EDIT" class="active_btn" @click="createSite(record.stationCode)">编辑</a>
        <a v-auth="$_ButtonPermission.SITEMANAGEMENT_STATUS" :class="{active_btn: true, delete: STATUS[record.status] === STATUS[1] }" @click="handleUpdata(record)">{{STATUS[record.status] === STATUS[1] ? '停用' : '启用'}}</a>
        <a v-auth="$_ButtonPermission.SITEMANAGEMENT_DELETE" class="active_btn" @click="deleteSite(record)">删除</a>
        <a class="action_btn" @click="handleRecord(record)">修改记录</a>
      </template>
    </a-table>
    </div>  
    <a-modal v-model="modalvisible" title="提交成功">
      <p>请等待几分钟后前往任务跟踪导出结果</p>
      <template slot="footer">
        <a-button
          key="back"
          v-track-click="{ trackName: '导出成功-立即查看' }"
          @click="toTask"
        >
          立即查看
        </a-button>
        <a-button key="submit" type="primary" @click="modalvisible = false">
          知道了
        </a-button>
      </template>
    </a-modal>
    <create-site ref="siteForm" @refresh="handleRefresh" />
    <record ref="recordRef"></record>
    <import-dialog ref="importRef" />
  </div>
</template>

<script>
import loadingMixin from "@thales/loading";
import ProSearch from '@/components/TableSearch/index.vue'
import {mapGetters} from 'vuex'
import record from './components/record.vue'
import { COLUMNS, STATUSPARAMS, STATUS,statusList,typeList,SearchFiled } from '../const'
import { getStationList, deleteStation, createExport } from '../api'
import CreateSite from './components/CreateSite.vue'
import ImportDialog from './components/import.vue'

export default {
  name: 'SiteManagement',
  components: {
    CreateSite,
    ProSearch,
    record,
    ImportDialog
  },
  mixins: [loadingMixin],
  data() {
    return {
      queryForm: {},
      SearchFiled,
      statusList,
      typeList,
      modalvisible: false,
      COLUMNS,
      STATUSPARAMS,
      STATUS,
      dataList: [],
      loading: {
        getData: false,
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
        },
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
    }
  },
  computed: {
    ...mapGetters('iframe', ['isWmsSystem']),
  },
  created() {
     const {creditCode}=this.$store.state.user
    if(!creditCode){
      this.SearchFiled=this.SearchFiled.filter(item=>item.name!=='customerCode')
      this.getData()
    }
  },
  methods: {
    async getData() {
      const { pagination, queryForm } = this
      const query = {
        size: pagination.pageSize,
        page: pagination.current,
        sort: 'createTime__DESC'
      }
      const res = await getStationList({
        ...queryForm,
        customerCode:this.$store.state.user.customerCode
      }, query)
      this.dataList = res.records
      this.pagination.total = res.total
    },
    handleImport(){
      this.$refs.importRef.show()
    },
    handleExport(){
      const { userId, userName, realName, tenantId, tenantName, customerCode, customerName, creditCode, corpName, accountName} = this.$store.state.user
      const params = {
        businessType: "CUSTOMER_STATION_EXPORT",
        reqParam: {
          ...this.queryForm,
          customerCode: this.$store.state.user.customerCode
        },
        tenantId,
        tenantName,
        userName: userName || realName,
        userId,
        customerCode: creditCode || customerCode,
        customerName: corpName || customerName || accountName,
      }
      createExport(params).then(() => {
        this.modalvisible = true
      })
    },
    toTask() {
      if (this.isWmsSystem) {
        window.parent.postMessage({}, '*');
        this.modalvisible = false;
        return;
      }
      this.$router.push('/task');
    },
    handleSearch(form){
      this.pagination.current=1
      this.queryForm={
        ...form,
        }
      this.getData();
    },
     handleReset(){
      this.pagination.current=1
      this.queryForm={}
      this.getData();
    },
    handleRefresh(){
      this.getData()
    },
    tableChange(pagination) {
      let { current } = pagination
      if (pagination.pageSize !== this.pagination.pageSize) {
        current = 1
      }
      this.pagination = {
        ...pagination,
        current,
      };
      this.getData();
    },
    createSite(stationCode) {
      this.$refs.siteForm.show(stationCode,'drawer',true)
    },
    deleteSite(row) {
      this.$confirm({
        title: '提示',
        content: '删除后将无法使用该站点下单/导入订单，且删除后不可恢复，是否确认删除？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async() => {
          return new Promise((resolve) => {
            deleteStation({
              id: row.id
            }).then(() => {
              this.pagination.current=1
              this.getData()
              resolve()
            })
          })
        }
      })
    },
    handleUpdata(t){
      this.$refs.siteForm.update(t.stationCode,t.status===0?1:0)
    },
    handleRecord(t){
      this.$refs.recordRef.show(t)
    }
  }
}
</script>

<style lang="less" scoped>
.site-management {
  .crate-btn {
    // text-align: right;
    margin-bottom:20px;
  }
  .status-tag {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #06B880;
    &.disabled {
      background: #ED4934;
    }
  }
}
.avail_form {
    /deep/.ant-form-item {
      width: 100%;
      .ant-form-item-label {
        width: 80px;
      }
      .ant-form-item-control-wrapper {
        width: calc(100% - 80px);
      }
    }
    .ant-col-6 {
      padding-right: 20px;
    }
    .form-btns {
      margin-left: 32px;
      line-height: 38px;
      .form-btn {
        margin-left: 20px;
      }
    }
  }
.search_btn {
  color: #06B880;
  border-color: #06B880;
}
.active_btn {
  margin: 0 10px;
  &.delete {
    color: #969799;
  }
}
.search-pane {
  padding: 24px;
  background-color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}
.table-content {
  padding: 24px;
  background-color: #fff;
  border-radius: 6px;
}
.avail_form {
  /deep/.ant-form-item-label label{
    color: #606266;
  }
  /deep/.ant-form-item-control-wrapper input {
    color: #171717;
  }
}
</style>
